import Stream from '../libs/Stream';

let decreaseOrderItemCountActionStream: Stream<number> = new Stream() as Stream<number>;

export default decreaseOrderItemCountActionStream;
